import React, { 
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  useState, 
  useEffect 
} from 'react';
import styled from 'styled-components';
import { FaCheckCircle, FaTimes } from 'react-icons/fa';
import { IconWrapper } from '../icons/IconWrapper';

interface NotificationProps {
  message: string;
  type: 'success' | 'error' | 'info';
  duration?: number;
  onClose: () => void;
  $isVisible: boolean;
}

const NotificationContainer = styled.div<{ $isVisible: boolean; type: string }>`
  position: fixed;
  top: 90px;
  right: 20px;
  padding: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background-color: ${({ theme, type }) => 
    type === 'success' ? theme.colors.success : 
    type === 'error' ? theme.colors.error : 
    theme.colors.primary};
  color: ${({ theme }) => theme.colors.light};
  box-shadow: ${({ theme }) => theme.shadows.medium};
  display: flex;
  align-items: center;
  max-width: 400px;
  opacity: ${({ $isVisible }) => $isVisible ? 1 : 0};
  transform: translateX(${({ $isVisible }) => $isVisible ? 0 : '100%'});
  transition: all 0.3s ease;
  z-index: 1000;
`;

const NotificationIcon = styled.div`
  margin-right: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NotificationContent = styled.div`
  flex: 1;
`;

const NotificationMessage = styled.p`
  margin: 0;
  font-size: 0.95rem;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.light};
  cursor: pointer;
  padding: 4px;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 1;
  }
`;

const Notification: React.FC<NotificationProps> = ({ 
  message, 
  type, 
  duration = 3000, 
  onClose,
  $isVisible
}) => {
  useEffect(() => {
    if ($isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [$isVisible, duration, onClose]);

  if (!$isVisible) return null;

  return (
    <NotificationContainer $isVisible={$isVisible} type={type}>
      <NotificationIcon>
        <IconWrapper icon={FaCheckCircle} size={18} />
      </NotificationIcon>
      <NotificationContent>
        <NotificationMessage>{message}</NotificationMessage>
      </NotificationContent>
      <CloseButton onClick={onClose}>
        <IconWrapper icon={FaTimes} size={16} />
      </CloseButton>
    </NotificationContainer>
  );
};

export default Notification; 